var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    _vm._l(_vm.filteredNews, function(item, index) {
      return _c(
        "div",
        { key: index, staticClass: "col-xs-12 col-sm-4  q-pa-md" },
        [
          _c(
            "q-card",
            { staticClass: "full-width full-height" },
            [
              _c(
                "q-card-media",
                {
                  staticClass: "cursor-pointer",
                  nativeOn: {
                    click: function($event) {
                      return _vm.openNews(item)
                    }
                  }
                },
                [
                  item.image
                    ? _c("img", { attrs: { src: item.image } })
                    : _vm._e(),
                  !item.image
                    ? _c("img", { attrs: { src: _vm.getPlaceholder } })
                    : _vm._e()
                ]
              ),
              _c("q-card-main", { staticStyle: { "min-height": "150px" } }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "q-subheading text-weight-medium text-primary title-library"
                  },
                  [_vm._v(_vm._s(item.title))]
                ),
                _c("p", { staticClass: "text-faded q-mt-md" }, [
                  _vm._v(_vm._s(_vm.fDate(item.publish_date)))
                ])
              ]),
              _c("q-card-separator"),
              _c(
                "q-card-actions",
                { staticClass: "justify-center" },
                [
                  _c("q-btn", {
                    staticClass: "full-width q-my-sm",
                    attrs: {
                      label: _vm.$t("open"),
                      icon: "fal fa-eye",
                      color: "secondary"
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.openNews(item)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }